export const FIELD_UPDATE_VALUE = 'FIELD_UPDATE_VALUE'
export const FORM_INIT = 'FORM_INIT'
export const FORM_LOAD = 'FORM_LOAD'
export const FORM_SET_CLONING = 'FORM_SET_CLONING'
export const FORM_SET_IN_POPUP = 'FORM_SET_IN_POPUP'
export const FORM_SET_DIRTY = 'FORM_SET_DIRTY'
export const FORM_SET_POPUP_URL = 'FORM_SET_POPUP_URL'
export const FORM_SET_DOCUMENT_UPLOAD_IN_PROGRESS = 'FORM_SET_DOCUMENT_UPLOAD_IN_PROGRESS'
export const OVERWRITE_DATA = 'OVERWRITE_DATA'
export const FORM_SAVE_DATA = 'FORM_SAVE_DATA'
export const FORM_VERIFICATION_DATA = 'FORM_VERIFICATION_DATA'
export const FORM_VEE_VALIDATION = 'FORM_VEE_VALIDATION'
export const FORM_REMOVE_ERROR_MESSAGE = 'FORM_REMOVE_ERROR_MESSAGE'
export const FORM_FETCH_STRUCTURE = 'FORM_FETCH_STRUCTURE'
export const FORM_FETCH_DATA = 'FORM_FETCH_DATA'
export const FORM_UPDATE_FIELD_DOCPROP_TITLE = 'FORM_UPDATE_FIELD_DOCPROP_TITLE'
export const FORM_UPDATE_FIELD_DOCPROP_DESC = 'FORM_UPDATE_FIELD_DOCPROP_DESC'
export const FORM_UPDATE_SUBFORM_BY_PATH = 'FORM_UPDATE_SUBFORM_BY_PATH'
export const FORM_UPDATE_SUBFORM_ROW_BY_PATH = 'FORM_UPDATE_SUBFORM_ROW_BY_PATH'
export const FORM_UPDATE_SUBFORM_CLEAR = 'FORM_UPDATE_SUBFORM_CLEAR'
export const FORM_LOCK_INFO = 'FORM_LOCK_INFO'
export const FORM_REFRESH = 'FORM_REFRESH'
export const FORM_UPDATE_GROUP_VALUE = 'FORM_UPDATE_GROUP_VALUE'
export const FORM_UPDATE_PAGE_VALUE = 'FORM_UPDATE_PAGE_VALUE'
export const FORM_UPDATE_READONLY = 'FORM_UPDATE_READONLY'
export const FORM_CLEAR_MAIN_TABLE = 'FORM_CLEAR_MAIN_TABLE'
export const FORM_UPDATE_FIELD_REQUIRED = 'FORM_UPDATE_FIELD_REQUIRED'
export const FORM_SET_READONLY = 'FORM_SET_READONLY'
export const FORM_SET_VERSION = 'FORM_SET_VERSION'
export const NEW_ELEMENT_KEY = 'NEW_ELEMENT_KEY'
export const SET_CAPTCHA_TEXT = 'SET_CAPTCHA_TEXT'
export const SET_CAPTCHA_VALUE = 'SET_CAPTCHA_VALUE'
export const SET_CAPTCHA_FIELD_PATH = 'SET_CAPTCHA_FIELD_PATH'
export const SET_FORM_CAPTCHA = 'SET_FORM_CAPTCHA'
export const ADD_SUB_FORM_ROW = 'ADD_SUB_FORM_ROW'
export const REMOVE_SUB_FORM_ROW = 'REMOVE_SUB_FORM_ROW'
export const SET_SUB_FORM_ROW_COLLAPSED = 'SET_SUB_FORM_ROW_COLLAPSED'
export const SET_NAMESPACE = 'SET_NAMESPACE'
export const FORM_UPDATE_PROP = 'FORM_UPDATE_PROP'
export const FORM_UPDATE_FIELD_VALUE = 'FORM_UPDATE_FIELD_VALUE'
export const UPDATE_PROP_BY_PATH = 'UPDATE_PROP_BY_PATH'
export const SET_ROW_UID = 'SET_ROW_UID'
export const SET_FIELD_TO_SKIP = 'SET_FIELD_TO_SKIP'
export const SET_TRIGGER_NAME = 'SET_TRIGGER_NAME'
export const SET_ACTIVE_PAGE_ID = 'SET_ACTIVE_PAGE_ID'
